import type {SafeHTMLString} from '@github-ui/sanitize/safe-html-string'
import type {SafeHtml} from '@github-ui/dotcom-schema/types/common/v1/safe_html'
import {setSanitizedInnerHTML} from '@github-ui/sanitize/set-inner-html'
import {mintUnsafeStaticHTML} from '@github-ui/trusted-types/unsafe-static'

type PullRequestLink = {
  url: string
  owner: string
  repository: string
  number: number
} & ({title: string; titleHtml?: never} | {title?: never; titleHtml: SafeHTMLString | SafeHtml})

export function buildPullRequestLink({url, owner, repository, number, title, titleHtml}: PullRequestLink) {
  const link = document.createElement('a')
  link.href = url
  if (titleHtml !== undefined) {
    setSanitizedInnerHTML(link, mintUnsafeStaticHTML(typeof titleHtml === 'string' ? titleHtml : titleHtml.value))
  } else {
    link.textContent = title
  }
  link.append(` (${owner}/${repository}#${number})`)

  return link
}
